import { useParams } from 'react-router-dom'

export const useActiveLeaseContractId = () => {
  const { id } = useParams()

  return { activeLeaseContractId: Number(id) }
}
